import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  root: {
    width: '100%',
    marginTop: UNIT
  },
  title: {
    fontSize: UNIT * 0.75
  },
  pos: {
    display: 'inline-block',
    fontSize: UNIT * 0.875
  },
  textStyle: { fontSize: UNIT },
  icon: {
    fontSize: UNIT * 1.5,
    color: mainColor.colorBlack,
    align: 'center'
  },
  progress: {
    margin: UNIT * 5,
    textAlign: 'center',
    color: mainColor.secondaryColor
  },
  textField: {
    marginLeft: UNIT * 0.5,
    marginRight: UNIT * 0.5,
    fontSize: UNIT
  },

  heading: {
    color: mainColor.colorBlackLight,
    fontSize: UNIT * 0.875,
    fontWeight: 'bolder'
  },
  tableRow: {
    height: 'fit-content',
    width: '100%'
  },
  specialHour: {
    fontSize: UNIT * 0.875,
    minWidth: UNIT * 12.5,
    height: UNIT * 3.75,
    color: 'gray',
    textAlign: 'center'
  },
  buttonSize: {
    textAlign: 'center',
    alignSelf: 'center',
    height: UNIT * 3.75,
    width: UNIT * 8
  },
  contentStyle: {
    paddingTop: UNIT * 1.25,
    paddingBottom: UNIT * 1.25,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  iconStyle: {
    width: UNIT * 1.5,
    height: UNIT * 1.5,
    align: 'center',
    margin: UNIT * 0.3125
  },
  addIcon: { fontSize: UNIT },
  choiceText: {
    alignSelf: 'center',
    fontSize: UNIT * 1.1875,
    color: `rgba(${mainColor.rgb}, 0.8)`
  },
  addButton: { alignSelf: 'baseline', marginTop: UNIT * 0.75, width: UNIT * 16.255 },
  removeButton: { width: UNIT, height: UNIT },
  modalBody: {
    backgroundColor: mainColor.backgroundColor
  }
});
